<template>
    <div class="">
        <profileApp></profileApp>
    </div>
</template>

<script>
import profileApp from '@/components/profile/profileApp.vue';
export default {
    name:'Profile',
    data:function(){
        return{
            pageName:'Profile Us from Json' , 
            pageDesc:'Profile Us Description From Json'
        }
    },
    components:{
        profileApp
    }
}
</script>